import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/SubscriptionFee/BrowseAllPlans.css';
import ckeckmark from '../../../Assets/ContainerStatus/Assets_Desktop/Checkmark.svg';
import cross from '../../../Assets/ContainerStatus/Assets_Desktop/crossmark.svg';
import greencheck from '../../../Assets/ContainerStatus/Assets_Desktop/radio-checked-green.svg';
import uncheck from '../../../Assets/ContainerStatus/Assets_Desktop/radio-unchecked.svg';
import hrLine from '../../../Assets/ContainerStatus/Assets_Desktop//horizontal-dotted-line.svg';
import SubscribeModal from '../../Shared/ManageSubscriptionModal';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { SUBSCRIPTION_PLANS_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { connect } from 'react-redux';
import { AES, enc } from 'crypto-js';

class BrowseAllPlans extends Component {
    constructor(props) {
        super(props)
        this.state = {
            allSubscriptionPlans: [],
            selectedPlan: 0,
            currentDate: '',
            hasOpen: false,
            hasOpenSubscribeModal: false,
            // preview profile approved value to process flow
            profileStatus: false,
            allTilesAccess: [{
                "tile": "Announcements",
                "previewAccess": "Yes",
                "premiumAccess": "Yes"
            }, {
                "tile": "Container Status",
                "previewAccess": "Limited",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Vessel Status",
                "previewAccess": "Limited",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Weather",
                "previewAccess": "Yes",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Truck Visits",
                "previewAccess": "Limited",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Request / Submit Quote",
                "previewAccess": "No",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Pre-Advise",
                "previewAccess": "No",
                "premiumAccess": 'Yes'
            },
            {
                "tile": "Truck Appointment",
                "previewAccess": "No",
                "premiumAccess": 'Yes'
            }
            ],
        }
    }
    getDate(timeStamp) {
        let day = new Date(timeStamp).getDate();
        let month = new Date(timeStamp).getMonth() + 1;
        let year = new Date(timeStamp).getFullYear();
        return `${day}/${month}/${year}`;
    }
    dateCompare = (d1, d2) => {
        let dateParts1 = d1.split("/");
        let dateParts2 = d2.split("/");
        let dateFoemate1 = new Date(dateParts1[2], dateParts1[1] - 1, dateParts1[0]).toString();
        let dateFoemate2 = new Date(dateParts2[2], dateParts2[1] - 1, dateParts2[0]).toString();
        const date1 = new Date(dateFoemate1);
        const date2 = new Date(dateFoemate2);
        if (date1 >= date2) {
            return true;
        }
        else if (date1 < date2) {
            return false;
        }
        else {
            return false;
        }
    }
    fetchDefaultPlans() {
        var rawSubsPlan = [];
        ApiCall(
            'GET',
            baseURL + SUBSCRIPTION_PLANS_ENDPOINT + '?type=Default',
            {},
            {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    rawSubsPlan = this.state.allSubscriptionPlans
                    data.map((plan, key) => {
                        if (plan.tenure == 'Monthly Default') {
                            plan.tenure = 'Monthly'
                        }
                        else if (plan.tenure == 'Yearly Default') {
                            plan.tenure = 'Yearly'
                        }
                    })
                    rawSubsPlan.map(function (a) {
                        if (a.tenure === 'Monthly') {
                            data = data.filter(function (i, n) {
                                return i.tenure === 'Yearly';
                            });
                            console.warn(data)
                        }
                        else if (a.tenure === 'Yearly') {
                            data = data.filter(function (i, n) {
                                return i.tenure === 'Monthly';
                            });
                            console.warn(data)
                        }
                    })
                    rawSubsPlan = rawSubsPlan.concat(data)
                    this.setState({
                        allSubscriptionPlans: rawSubsPlan
                    })
                }
            }
        })
    }
    // apiCall for all base plans
    getBasePlansApi = () => {
        ApiCall(
            'GET',
            baseURL + SUBSCRIPTION_PLANS_ENDPOINT,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((data) => {
            if (data.flag != -1) {
                if (data.flag == 500) {
                    console.log('I am 500!');
                    this.fetchDefaultPlans();
                }
                else {
                    console.log('I am 200!');
                    let currentDate =
                        this.getDate(new Date());
                    let filteredData = data;
                    filteredData = filteredData?.filter(item => this.dateCompare(currentDate, item.fromDate) && item.activeFlag);
                    if (filteredData?.length == 2) {
                        this.setState({ allSubscriptionPlans: filteredData });
                    }
                    else if (filteredData?.length == 1) {
                        this.setState({
                            allSubscriptionPlans: filteredData
                        });
                        this.fetchDefaultPlans();
                    }
                    else {
                        this.fetchDefaultPlans();
                    }
                }
            }
        });
    }
    componentDidMount() {
        // apiCall for all base plans
        this.getBasePlansApi();
        this.props.userProfileDataR?.profileRoles?.every((md, index) => {
            if (['Requester', 'Respondent', 'requester', 'respondent'].includes(md.roleType) && ["Approved", 'approved'].includes(md.profileStatus)) {
                this.setState({ profileStatus: true });
                return false
            }
            return true
        })
    }
    onCloseSubscribeModal = () => {
        this.setState({ hasOpenSubscribeModal: false });
    }
    onClickSubscribeModal = () => {
        this.setState({ hasOpenSubscribeModal: false });
        this.props.history.push('/ManageSubscription', {})
    }
    onCloseModal = () => {
        this.setState({ hasOpen: false });
    }
    onClickModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/ManageSubscription', {})
    }
    onSubscribe = () => {
        if (this.props.userProfileDataR?.userType == "Premium") {
            this.setState({ hasOpen: true });
        }
        else if (this.props.userProfileDataR?.userType == "Preview" && !this.state.profileStatus) {
            this.setState({ hasOpenSubscribeModal: true });
        }
        else if (this.props.userProfileDataR?.userType == "Preview" && this.state.profileStatus) {
            this.props.history.push({
                pathname: `/paymentProcess/${this.state.allSubscriptionPlans[this.state.selectedPlan]?.planId}`,
                state: this.state.allSubscriptionPlans[this.state.selectedPlan]
            });
        }
    }
    selectPlan(planNo) {
        this.setState({ selectedPlan: planNo });
        console.log("plan id", planNo);
    }
    render() {
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.browseAllPlansPageTitle} description={TitleDescription.browseAllPlansPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="bpcsnofull">
                    <div id="bpcsnobox1">
                        <nav class="rnononavbar">
                            <div className="rnonavbarname">
                                <small id="nonavc">Manage Subscription</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="managementmaincard">
                            <div>
                                <div class="bpdivout">
                                    <div class="bpdivin">
                                        <table class="bpdivtable">
                                            <tr>
                                                <td class="bpdivcol1">Access</td>
                                                <td class="bpdivcol2"><div class="bpdivwidth"><small class="bpdivcolsm">Preview (Free)</small></div></td>
                                                <td class="bpdivcol3"><div class="bpdivwidthmidil"><small class="bpdivcolsm">Premium (Paid)</small></div></td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div>
                                        {(this.state.allTilesAccess.map((dataplan, index) => {
                                            return (<div class="bpdivin1" id="advertisementdata">
                                                <table class="bpdivtable">
                                                    <tr>
                                                        <td class="bpdivcol11">{dataplan.tile}</td>
                                                        <td class="bpdivcol2">
                                                            <div class="bpdivwidth">
                                                                {dataplan.previewAccess === 'Limited' ? <small class="bpdivcolsmlimit">Limited</small> : <img src={dataplan.previewAccess === "Yes" ? ckeckmark : cross} />}
                                                            </div>
                                                        </td>
                                                        <td class="bpdivcol3">
                                                            <div class="bpdivwidth">
                                                                {dataplan.premiumAccess === 'Limited' ? <small class="bpdivcolsmlimit">Limited</small> : <img src={dataplan.premium === "No" ? cross : ckeckmark} />}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                            );
                                        }))}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="bptwohed">
                                    <small class="bptwohedsm">Select Your Premium Subscription Plan</small>
                                </div>
                                <div class="AllSubscriptionPlanDiv">
                                    <div class="AllSubscriptionPlanInnDiv"> {(this.state.allSubscriptionPlans.map((dataplan, index) => {
                                        return (
                                            <>
                                                {index < (this.state.allSubscriptionPlans.length / 2) &&
                                                    <div class="bptwocard11" id={this.state.selectedPlan === index ? "cardgreenbordershow" : "cardgreenborder"}>
                                                        <div class="bpcrdup">
                                                            <small class="bpcrdupsm">{dataplan.tenure}</small>
                                                            <img src={this.state.selectedPlan === index ? greencheck : uncheck} key={index} onClick={() => this.selectPlan(index)} />
                                                        </div>
                                                        <div class={(dataplan.recommendFlag) ? "bpcrdup22" : "bpcrdup2"}>
                                                            <div class="bpcrdup222">
                                                                <small class={(dataplan.recommendFlag) ? "bpcrdupsm1recommonded" : "bpcrdupsm1"}>
                                                                    <small class="bpcrdupsm2">R </small>
                                                                    <small class="bpcrdupsm3">{dataplan.totalAmount}</small>
                                                                </small>
                                                                {(dataplan.recommendFlag) &&
                                                                    <div class="recomonded">
                                                                        <div class="recomondeddiv">
                                                                            <small class="recomondedsm">RECOMMENDED</small>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </>
                                        );
                                    }))}
                                    </div>
                                    <div class="AllSubscriptionPlanInnDivRight">
                                        {(this.state.allSubscriptionPlans.map((dataplan, index) => {
                                            return (
                                                <>
                                                    {index >= (this.state.allSubscriptionPlans.length / 2) &&
                                                        <div class="bptwocard11right" id={this.state.selectedPlan === index ? "cardgreenbordershow" : "cardgreenborder"}>
                                                            <div class="bpcrdup">
                                                                <small class="bpcrdupsm">{dataplan.tenure}</small>
                                                                <img src={this.state.selectedPlan === index ? greencheck : uncheck} key={index} onClick={() => this.selectPlan(index)} />
                                                            </div>
                                                            <div class={(dataplan.recommendFlag) ? "bpcrdup22" : "bpcrdup2"}>
                                                                <div class="bpcrdup222">
                                                                    <small class={(dataplan.recommendFlag) ? "bpcrdupsm1recommonded" : "bpcrdupsm1"}>
                                                                        <small class="bpcrdupsm2">R </small>
                                                                        <small class="bpcrdupsm3">{dataplan.totalAmount}</small>
                                                                    </small>
                                                                    {(dataplan.recommendFlag) &&
                                                                        <div class="recomonded">
                                                                            <div class="recomondeddiv">
                                                                                <small class="recomondedsm">RECOMMENDED</small>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            );
                                        }))}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="bpmscarddiv3">
                                    <div class="mscarddivbuttout">
                                        <Button class="mscarddivbutt" onClick={this.onSubscribe} >Subscribe</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bpnotifooter01">
                    <Footer />
                </div>
                <div class="bpnotifooter02">
                    <Footer2 />
                </div>
                {/* already premium member */}
                <SubscribeModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onClickModal={this.onClickModal}>
                    <div className="alertModalContent">
                        <p className="modalContent">You are already subscribed to Cargo Connect Premium.</p>
                    </div>
                </SubscribeModal>
                {/* profile not approved by admin */}
                <SubscribeModal hasOpen={this.state.hasOpenSubscribeModal} onCloseModal={this.onCloseSubscribeModal} onClickModal={this.onClickSubscribeModal}>
                    <div className="modalHeading">
                        <p className="modalHeadingText">You cannot subscribe until your Requester or Respondent profile is approved by admin.</p>
                    </div>
                    <div className="sectionContainer">
                        <img src={hrLine} alt="Horizontal Dotted Line" className="lineStyle" />
                        <div className="modalInnerContent">
                            <div className="leftInnerContent"><p className="stepText">Step 1</p></div>
                            <div className="rightInnerContent">
                                <p className="stepsDetail">Add Requester / Respondent profile and submit for approval</p>
                            </div>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="lineStyle" />
                        <div className="modalInnerContent">
                            <div className="leftInnerContent"><p className="stepText">Step 2</p></div>
                            <div className="rightInnerContent">
                                <p className="stepsDetail">Approved by admin</p>
                            </div>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="lineStyle" />
                        <div className="modalInnerContent">
                            <div className="leftInnerContent"><p className="stepText">Step 3</p></div>
                            <div className="rightInnerContent">
                                <p className="stepsDetail">Pay subscription fees</p>
                            </div>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="lineStyle" />
                    </div>
                </SubscribeModal>
            </div>
        );
    }
}
function mapStateToProps(state) {
    if (state.userProfileInfoReducer.data) {
        return {
            userProfileDataR: JSON.parse(AES.decrypt(state.userProfileInfoReducer.data, 'TPT_CARGO_CONNECT').toString(enc.Utf8))
        }
    }
}
export default connect(mapStateToProps)(BrowseAllPlans);
